export const LIST_ALL = "/v1/appointment/staff/list/all";